import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({
  selector: 'app-tanker-execution-report',
  templateUrl: './tanker-execution-report.component.html',
  styleUrls: ['./tanker-execution-report.component.css']
})
export class TankerExecutionReportComponent implements OnInit {
  reportList: any[] = [];
  searchList: any[] = [];
  tankerList: any[] = [];
  clientList: any[] = [];

  mdl_Search: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    strSDate: new FormControl(moment().subtract(30, 'day').format('jYYYY/jMM/jDD'), Validators.required),
    strEDate: new FormControl('', Validators.required),
    strUnitID: new FormControl(''),
    iTanker_WaterClient: new FormControl('-1'),
  })

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  async fetchData() {
    this.fetchTankers();
    this.fetchClients();

  }

  async fetchTankers() {
    this._otherService.Showspinner();

    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    }

    let res = JSON.parse((await axios.post('Tanker_List4DeliverySchedule', this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner()

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '14' } });

      return;

    }

    if (res.iResult == 0)
      return this._tooltip.showError(res.strError);

    this.tankerList = res;

  }

  async fetchClients() {
    this._otherService.Showspinner();

    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    }

    let res = JSON.parse((await axios.post('Tanker_WaterClient_List4DeliverySchedule', this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner()

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '14' } });

      return;

    }

    if (res.iResult == 0)
      return this._tooltip.showError(res.strError);

    this.clientList = res;

  }

  async fetchReports() {
    this._otherService.Showspinner();

    const model = this._otherService.stringNumberToNumber(this.mdl_Search.value);

    let res = JSON.parse((await axios.post('Tanker_DeliverySchedule_Search', model)).data.toString());

    this._otherService.nonespinner()

    if (res.ISSessionExpired == true) {

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '14' } });

      return;

    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.reportList = res;
    this.searchList = res;

  }

  async filterResult(strValue: string) {
    if (strValue.length > 1) {
      this.reportList = this.searchList.filter((el: any) => {
        return el.iTanker_DeliverySchedule.toString().includes(strValue) ||
          el.iTanker_DeliverySchedule.toString().includes(strValue) ||
          el.strClientName.includes(strValue)
      })
    }
    else if (strValue == '') {
      this.reportList = this.searchList
    }
  }

}
